import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScanSearch } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import type { DrawingEvidence } from '../../../types/drbfm';
import { drawingEvidenceLabel, formatPercent } from './decisionMemoryText';

interface DrawingEvidenceSectionProps {
  evidence: DrawingEvidence;
  onOpen: () => void;
}

const DrawingEvidenceSection: React.FC<DrawingEvidenceSectionProps> = ({ evidence, onOpen }) => {
  const { t } = useTranslation();

  return (
    <>
      <Separator />
      <div className="rounded-md border p-3">
        <p className="revy-cjk mb-2 text-sm font-medium leading-[1.5]">{drawingEvidenceLabel(t, evidence)}</p>
        <p className="revy-cjk revy-figure text-xs leading-[1.5] text-muted-foreground">
          {t('drbfm.decisionMemory.confidence', {
            value: formatPercent(evidence.confidence),
            defaultValue: `信頼度 ${formatPercent(evidence.confidence)}`,
          })}
        </p>
        {evidence.reasoning && (
          <p className="revy-cjk mt-2 text-sm leading-[1.6] text-muted-foreground">
            {evidence.reasoning}
          </p>
        )}
        <Button size="sm" className="mt-3" onClick={onOpen}>
          <ScanSearch strokeWidth={1.9} />
          <span className="revy-cjk">{t('drbfm.decisionMemory.confirmInDrawing', '図面で確認')}</span>
        </Button>
      </div>
    </>
  );
};

export default DrawingEvidenceSection;
